var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer pt-2" }, [
    _c(
      "div",
      { staticClass: "row align-items-center justify-content-lg-between" },
      [
        _c("div", { staticClass: "col-lg-6" }, [
          _c(
            "div",
            { staticClass: "copyright text-center  text-lg-left  text-muted" },
            [
              _vm._v(
                " © " + _vm._s(_vm._f("moment")(new Date(), "YYYY")) + " "
              ),
              _c(
                "a",
                {
                  staticClass: "font-weight-bold ml-1",
                  attrs: { href: "javascript:;" }
                },
                [_vm._v("Brisk")]
              )
            ]
          )
        ]),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6 d-none" }, [
      _c(
        "ul",
        {
          staticClass:
            "nav nav-footer justify-content-center justify-content-lg-end"
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "https://www.creative-tim.com",
                  target: "_blank"
                }
              },
              [_vm._v("Creative Tim")]
            )
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "https://www.creative-tim.com/presentation",
                  target: "_blank"
                }
              },
              [_vm._v("About Us")]
            )
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "http://blog.creative-tim.com",
                  target: "_blank"
                }
              },
              [_vm._v("Blog")]
            )
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href:
                    "https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md",
                  target: "_blank"
                }
              },
              [_vm._v("MIT License")]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }